/**
 * M3-3 — Machine Groups (admin fleet membership under Machine, not Fleet city).
 * Soft≠Live: reuses Fleet Groups / Group Live buses; URL owns selection.
 * Mount: /machine/groups | /machine/groups/:id
 * SHELL-1: cross-primary CTAs use leave-seat confirm.
 */
import { html, go } from "./ui.js";
import { FleetGroupsDesk } from "./fleet-groups-desk.js";
import { GroupPage } from "./fleet-group-desk.js";
import { confirmLeaveSeat } from "./shell-wayfind.js";

export default function MachineGroups({ groupId, toast }) {
  const gid = String(groupId || "").trim();
  return html`<div className="sheet machine-groups machine-deck machine-hub desk-craft mh-rack mh-open" data-cmc-m3="m3-3"
      data-cmc-shell="machine-ux" data-cmc-machine-flat="1" data-rack="1" data-open="1">
    <div className="wrap machine-hub__in mh-rack__in">
      <header className="machine-hub__chrome mh-rack__bar mh-open__mast" aria-label="Machine groups">
        <div className="machine-hub__id mh-rack__brand mh-open__brand">
          <h1 className="machine-hub__title">Groups</h1>
          <small className="machine-v2__lede">Membership for scoped Cap and targeting — empty groups stay empty</small>
        </div>
        <nav className="machine-hub__seats mh-rack__seats" aria-label="Machine seats">
          <button type="button" className="machine-hub__seat" onClick=${() => go("/machine")}>Estate</button>
          <button type="button" className="machine-hub__seat" data-on="1">Groups</button>
          <button type="button" className="machine-hub__seat"
            onClick=${() => confirmLeaveSeat({
              fromRoute: "/machine/groups",
              targetPath: "/skills/assign",
            })}>Scoped Cap</button>
        </nav>
        <div className="machine-hub__tools mh-rack__actions">
          <button type="button" className="btn btn--ghost btn--sm"
            onClick=${() => confirmLeaveSeat({ fromRoute: "/machine/groups", targetPath: "/skills/waves" })}>
            Cap rollout</button>
          <button type="button" className="btn btn--ghost btn--sm"
            onClick=${() => confirmLeaveSeat({ fromRoute: "/machine/groups", targetPath: "/ops/areas" })}>
            Areas</button>
        </div>
      </header>
      <div className="mh-rack__etch" aria-hidden="true"><i/><i/><i/></div>
      <p className="note machine-hub__note">
        Full-fleet Cap publish stays on OTA. This desk only stages membership.
      </p>
      ${gid
        ? html`<${GroupPage} name=${gid} toast=${toast}/>`
        : html`<${FleetGroupsDesk} toast=${toast}/>`}
    </div>
  </div>`;
}
